import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import {
  WellnessCheckInDomain,
  WellnessCheckInDomainToTitle,
} from '@lyrahealth-inc/shared-app-logic/src/features/wellnessCheckIn/constants'

import { FinancesAndWorkIllustration } from '../../atoms/illustrations/FinancesAndWorkIllustration'
import { MoodAndEmotionsIllustration } from '../../atoms/illustrations/MoodAndEmotionsIllustration'
import { PhysicalHealthAndActivityIllustration } from '../../atoms/illustrations/PhysicalHealthAndActivityIllustration'
import { ResilienceAndCopingIllustration } from '../../atoms/illustrations/ResilienceAndCopingIllustration'
import { RolesAndRelationshipsIllustration } from '../../atoms/illustrations/RolesAndRelationshipsIllustration'
import { SpiritualityAndExplorationIllustration } from '../../atoms/illustrations/SpiritualityAndExplorationIllustration'
import { Title, Size as TitleSize } from '../../atoms/title/Title'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

const WELLNESS_CHECK_IN_DOMAIN_TO_ICON: Record<WellnessCheckInDomain, React.ReactNode> = {
  [WellnessCheckInDomain.MoodAndEmotions]: <MoodAndEmotionsIllustration />,
  [WellnessCheckInDomain.ResilienceAndCoping]: <ResilienceAndCopingIllustration />,
  [WellnessCheckInDomain.RolesAndRelationships]: <RolesAndRelationshipsIllustration />,
  [WellnessCheckInDomain.PhysicalHealthAndActivity]: <PhysicalHealthAndActivityIllustration />,
  [WellnessCheckInDomain.FinancesAndWork]: <FinancesAndWorkIllustration />,
  [WellnessCheckInDomain.SpiritualityAndExploration]: <SpiritualityAndExplorationIllustration />,
}

const Container = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing['12px'],
}))

/**
 * Displays domain name and illustration
 * Used in header throughout the Wellness Check In flow
 */
export const WellnessCheckInDomainHeader: FunctionComponent<{
  wellnessCheckInDomain: WellnessCheckInDomain
  iconOnLeft?: boolean
}> = ({ wellnessCheckInDomain, iconOnLeft = false }) => {
  const intl = useIntl()
  const icon = WELLNESS_CHECK_IN_DOMAIN_TO_ICON[wellnessCheckInDomain]
  return (
    <Container testID={tID('WellnessCheckInDomainHeader')}>
      {iconOnLeft && icon}
      <Title text={intl.formatMessage(WellnessCheckInDomainToTitle[wellnessCheckInDomain])} size={TitleSize.XSMALL} />
      {!iconOnLeft && icon}
    </Container>
  )
}
